function closeModal(should_reload_parent) {
    var $parent_body = $(parent.document.getElementsByTagName('body')[0]);
    if(should_reload_parent)
    {
        parent.document.location.reload();
    }
    $parent_body.find("#cconma-modal-container").remove();
}

(function (root, factory) {
    // AMD(require.js) ready?
    if (typeof define === 'function' && define.amd)
    {
        // window에 jquery가 있으면 no-dependency
        if (root.$ || root.jQuery)
        {
            define([], factory);
        }
        // window에 jquery가 없음.
        else
        {
            define(["jquery"], factory);
        }
    }
    else
    {
        root.modal = factory();
    }
})(this, function (optionalJquery) {

    var callerResolve;
    var callerReject;
    var $; // local jQuery

    // inject 안되었나(고전 방식)?
    if (typeof optionalJquery === "undefined")
    {
        $ = window.$ || window.jQuery;
    }
    else
    {
        $ = optionalJquery;
    }

    /**
     * @param {Object} [win]
     */
    return function (html, width, height, win, backdrop, modal_id) {
        return new Promise(function (resolve, reject) {

            if (modal_id === undefined || modal_id === null)
            {
                modal_id = ""
            }

            callerResolve = resolve;
            callerReject = reject;
            win = win || window;

            // 모달 CSS 스타일을 head에 인젝트
            var css = "#cconma-modal-container" + modal_id + "{position:fixed;z-index:9999;left:0;top:0;width:100%;height:100%;overflow:auto;background-color:rgba(3,3,3,0.8)}#cconma-modal-container" + modal_id + " #cconma-modal-wrap" + modal_id + "{margin:0" +
                " auto;position:absolute;background-color:white;box-sizing:content-box;border:1px solid #dedede;left: 50%;top: 50%;max-height: calc(100% - 60px);transform: translate(-50%, -50%);}" +
                " #cconma-modal-container" + modal_id + " #cconma-modal-wrap" + modal_id + " #cconma-modal-body" + modal_id + " iframe{width:100%;height:100%;box-sizing:border-box;border:0}" +
                " #cconma-modal-container" + modal_id + " #cconma-modal-wrap" + modal_id + " #close-cconma-modal-btn" + modal_id + "{position:absolute;top:-45px;right:10px;cursor:pointer;width:24px;height:24px;}" +
                " #cconma-modal-container" + modal_id + " #cconma-modal-wrap" + modal_id + " #close-cconma-modal-btn" + modal_id + " img{width:100%;}" +
                " #cconma-modal-container" + modal_id + " #cconma-modal-wrap" + modal_id + " #cconma-modal-body{max-height:100%}";

            var styleTag = win.document.createElement('STYLE');
            styleTag.type = 'text/css';
            if (styleTag.styleSheet)
            {
                styleTag.styleSheet.cssText = css;
            }
            else
            {
                styleTag.appendChild(win.document.createTextNode(css));
            }
            var head = win.document.head || win.document.getElementsByTagName('head')[0];
            head.appendChild(styleTag);
            // 모달 CSS 스타일 인젝트 끝

            // 모달 wrapper + HTML을 body 끝에 인젝트
            var render_html =
                "<div id='cconma-modal-container" + modal_id + "'>" +
                "   <div id='cconma-modal-wrap" + modal_id + "' style='width:" + width + "px;height:" + height + "px'>" +
                "       <span id='close-cconma-modal-btn" + modal_id + "'><img src='https://cconma-usa.gcdn.ntruss.com/assets/icons/icon-close-white.png'></span>" +
                "       <div id='cconma-modal-body" + modal_id + "' style='width:" + width + "px;height:" + height + "px;'>" + html +
                "       </div>" +
                "   </div>" +
                "</div>";

            var $body = $(win.document.getElementsByTagName('body')[0]);
            $body.append(render_html);
            // 모달 wrapper + HTML을 body 끝에 인젝트 끝

            // 모달 닫기 버튼 클릭시
            $body.on("click", "#close-cconma-modal-btn" + modal_id + "", function () {
                $body.find("#cconma-modal-container" + modal_id + "").remove();
                callerResolve();
            });

            // 'static' 이 아닌 경우에만 배경을 클릭했을때 modal이 닫힘.
            if (backdrop !== 'static')
            {
                // 모달 배경(컨테이너) 클릭시 모달 제거
                $body.find("#cconma-modal-container" + modal_id + "").on("click", function (e) {
                    var $elm = $("#cconma-modal-wrap" + modal_id + "");
                    if (!$elm.is(e.target)
                        && $elm.has(e.target).length === 0)
                    {
                        $body.find("#cconma-modal-container" + modal_id + "").remove();
                        callerResolve();
                    }
                });
            }
        });
    };
});